<!-- 平面图win窗体 -->
<template>
    <div class="height-percent-100">
        <!-- 内容展示区 如果是组织单元  则不存在内容展示区 默认不展示-->
        <PmContent class="height-percent-100" :carrierArray="carrierArray" :carrierSencen="carrierSencen" :treeObj="treeObj" :pmObj.sync="pmObj" />
    </div>
</template>

<script>
import { shareParam } from '@/api/modules/public.js';
import { sceneGetPlanDetail, carrierGetCarrierBySceneId } from '@/api/modules/architecture.js';
// import PmContent from './component/pmcontent/PmContent.vue';
import PmContent from '../../../applied/components/arch/right/PmContent.vue';
export default {
    components: {
        PmContent
    },
    data() {
        return {
            pmObj: {}, // 平面图数据
            carrierArray: [], // 监测点状态
            stautsIconArray: [
                // 监测点状态
                'iconfont icon-yunhang',
                'iconfont icon-beiyong',
                'iconfont icon-baofei',
                'iconfont icon-daixiugai',
                'iconfont icon-chushuang'
            ],
            // 监测点类型
            carrierIconArray: [
                {
                    type: 1,
                    icon: 'iconfont icon-weibolu-xian'
                },
                {
                    type: 2,
                    icon: 'iconfont icon-bingxiang'
                },
                {
                    type: 3,
                    icon: 'iconfont icon-9lengku'
                },
                {
                    type: 4,
                    icon: 'iconfont icon-9lengku'
                }
            ],
            // 架构关联的监测点
            carrierSencen: [],
            treeObj: {} // 点击树形数据
        };
    },
    mounted() {
        this.getNodeClickTreeFn();
    },
    methods: {
        // 树节点功能类型，0-单元节点，1-平面图节点，2-地图节点
        getNodeClickTreeFn() {
            // query参数没有找到就去缓存里找
            let row;
            if (this.$route.query && this.$route.query.sceneId) {
                row = { sceneId: this.$route.query.sceneId };
            } else row = JSON.parse(sessionStorage.getItem('homeTreeData'));
            this.treeObj = { ...row };
            this.getPmContent({ sceneId: row.sceneId });
            this.getCarrierData({ sceneId: row.sceneId });
            this.getCarrierStatus();
        },
        // PromiseRace(){
        //   return Promise.race([])
        // },
        getPmContent(obj) {
            sceneGetPlanDetail(obj).then(({ result }) => {
                this.pmObj = result;
            });
        },
        getCarrierData(obj) {
            carrierGetCarrierBySceneId(obj).then(({ result }) => {
                result.forEach(item => {
                    this.carrierIconArray.forEach(opt => {
                        if (item.typeId === opt.type) {
                            item.icon = opt.icon;
                        }
                    });
                });
                this.carrierSencen = result;
            });
        },
        getCarrierStatus() {
            shareParam({ code: 'carrier_status_item', type: 0 }).then(({ result }) => {
                result.forEach((item, index) => {
                    item.icon = this.stautsIconArray[index];
                });
                this.carrierArray = result;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.rightContent {
    height: 100%;
    flex: 1;
    background-color: #fff;

    .content {
        height: calc(100% - 50px);
        padding: 10px;
        box-sizing: border-box;
    }
}
</style>
